query AnalyticsViewsByContent($filter: AnalyticsViewsFilterInput!, $limit: Int) {
  analyticsViews(filter: $filter) {
    viewsByContent(limit: $limit) {
      contentId
      title
      views
      visitors
    }
  }
}
